import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import { defaultDateFormat } from 'Common/GeneralHelper';
import { Filter, Main } from 'Containers/';
import { LoadingPage, TitledCard } from 'Components/';
import SelectSitesTable from 'Common/SelectSitesTable';
import { ReportGeneration } from 'Common/ObjectHelper';
import { toastType, createToast, toastError } from 'Common/ToastHelper';
import { AccuclaimEditForm } from './components/AccuclaimEditReportForm';
import { ACCUCLAIM_EDIT_REPORT_FORM_NAME } from 'Common/FormEnum';
import { AccuclaimEditReportFieldEnum as Fields } from 'Common/FieldEnum';
import {
  getAccuclaimEditReport,
  clearReport,
  setSelectedSites,
} from './state/report/actions';

class AccuclaimEditReportContainer extends Component {
  handleSubmit = formValues => {
    if (this.props.selectedSites && this.props.selectedSites.length === 0) {
      toastError('You must select at least one site');
      return;
    }
    // The Form and sites table are seperate, so they are combined into one object
    const values = { ...formValues, selectedSites: this.props.selectedSites };
    this.props.getAccuclaimEditReport(values);
  };

  onSiteChange = selectedSites => {
    this.props.setSelectedSites(selectedSites);
  };

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: ACCUCLAIM_EDIT_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidUpdate(prevProps, prevState) {
    const { report } = this.props;
    if (report && prevProps.report !== report) {
      if (report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(report, 'Accuclaim Edit Report');
      }
      this.props.clearReport();
    }
  }

  render() {
    return (
      <Fragment>
        {this.props.loading ? <LoadingPage /> : undefined}
        <Filter title={'Accuclaim Edit Report'} />
        <Main {...this.getMainProps()}>
          <TitledCard title={'Filters'}>
            <AccuclaimEditForm
              onSubmit={this.handleSubmit}
              loading={this.props.loading}
              initialValues={{
                [Fields.FeedingType]: 0,
                [Fields.SummaryType]: 0,
                [Fields.PrintComments]: false,
                [Fields.OmitChanges]: false,
                [Fields.FromDate]: defaultDateFormat(moment()),
                [Fields.ToDate]: defaultDateFormat(moment()),
              }}
            />
          </TitledCard>
          <TitledCard title={'Sites'}>
            <SelectSitesTable onChange={this.onSiteChange} />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { accuclaimEdit } = state.AccuclaimEditState;
  return {
    loading: accuclaimEdit.loading,
    report: accuclaimEdit.report,
    selectedSites: accuclaimEdit.selectedSites,
  };
};

export const AccuclaimEdit = withRouter(
  connect(mapStateToProps, {
    getAccuclaimEditReport,
    clearReport,
    setSelectedSites,
  })(AccuclaimEditReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/accuclaimedit/AccuclaimEdit.js